import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import StepsOverview from './components/StepsOverview';
import StepDetail from './components/StepDetail';
import Differentiation from './components/Differentiation';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookieSettings from './components/CookieSettings';
import Footer from './components/Footer';
import Auth from './components/Auth';
import { stepsTranslations, translations } from './translations/content';
import supabase from './supabase/supabase';
import './App.css';

const AppContent = () => {
  const { lang } = useLanguage();
  const steps = stepsTranslations[lang];
  const p = translations[lang].paths;
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Routes>
        <Route path="/" element={
          <main>
            <Hero />
            <Contact />
          </main>
        } />
        {/* Dedicated Differentiation / Niche Finder Page */}
        <Route path="/find-your-niche" element={<Differentiation />} />
        <Route path="/finde-deine-Nische" element={<Differentiation />} />
        
        <Route path="/steps" element={<StepsOverview steps={steps} />} />
        <Route path="/schritte" element={<StepsOverview steps={steps} />} />
        <Route path="/steps/:id" element={<StepDetail />} />
        <Route path="/schritte/:id" element={<StepDetail />} />
        <Route path="/auth" element={session ? <Navigate to="/steps" /> : <Auth />} />
        <Route path="/login" element={session ? <Navigate to="/steps" /> : <Auth initialIsLogin={true} />} />
        <Route path="/register" element={session ? <Navigate to="/steps" /> : <Auth initialIsLogin={false} />} />
        <Route path="/registrieren" element={session ? <Navigate to="/steps" /> : <Auth initialIsLogin={false} />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/datenschutz" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/agb" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookieSettings />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;